import { render } from "./PrimeiroAcesso.vue?vue&type=template&id=5f0aac8a&scoped=true"
import script from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
export * from "./PrimeiroAcesso.vue?vue&type=script&lang=js"

import "./PrimeiroAcesso.vue?vue&type=style&index=0&id=5f0aac8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0aac8a"]])

export default __exports__